import { render, staticRenderFns } from "./WorldAddLink.vue?vue&type=template&id=ae149a22&scoped=true&"
import script from "./WorldAddLink.vue?vue&type=script&lang=js&"
export * from "./WorldAddLink.vue?vue&type=script&lang=js&"
import style0 from "./WorldAddLink.vue?vue&type=style&index=0&id=ae149a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae149a22",
  null
  
)

export default component.exports